




































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import EnumButton = DisguiseDto.EnumButton;
import EnumColor = DisguiseDto.EnumColor;
import DTUrlParameterDto = DisguiseDto.DTUrlParameterDto;
import {COLOR_SERVICE_INSTANCE} from '@/services/style/color.service';
import {ICONS_SERVICE_INSTANCE, IconsService} from '@/utils/icons.service';


export interface AmetrasButtonButtonState {
    loading: boolean;
}

export interface AmetrasBtnEventData {
    event: Event | undefined;
    button: DisguiseDto.EnumButton | undefined;
    url: string;
    dialogId: number;
    promtInput: string;
    urlParameters?: DTUrlParameterDto[];
    dialogTitle: string;
    canSubmit: boolean;
    buttonState: AmetrasButtonButtonState;
}
@Component
export default class AmetrasButtonTemplate extends Vue {
    @Prop() icon!: DisguiseDto.DisguiseIcon;
    @Prop() bgColor!: EnumColor;
    @Prop() url!: string;
    @Prop() button!: EnumButton;
    @Prop() title!: string;
    @Prop() iconColor!: EnumColor;
    @Prop() hasConfirmDialogs!: boolean;
    @Prop() defaultDialogId!: number;
    @Prop() disableIfDirty!: boolean;
    @Prop() formValid!: boolean;
    @Prop() formDirty!: boolean;
    @Prop() disableNotValid!: boolean;
    @Prop() dialogTitle!: string;
    @Prop() triggerOnEnter!: boolean;
    @Prop() canSubmit!: boolean;
    @Prop({
        type: Array as () => DisguiseDto.DTUrlParameterDto[], required: false, default: () => {
            return [];
        }
    }) urlParameters!: DisguiseDto.DTUrlParameterDto[];
    isOnlyIcon: boolean = false;

    buttonState: AmetrasButtonButtonState = {
        loading: false
    };

  iconService: IconsService = ICONS_SERVICE_INSTANCE;

    onClick(event: Event) {
        const buttonEventData: AmetrasBtnEventData = {
            event,
            button: this.button,
            url: this.url,
            dialogId: this.defaultDialogId,
            urlParameters: this.urlParameters,
            dialogTitle: this.dialogTitle,
            canSubmit: this.canSubmit,
            promtInput: '',
            buttonState: this.buttonState,
        };

        this.$emit('ametrasbtnclick', buttonEventData);
    }

    get textColor() {
        return COLOR_SERVICE_INSTANCE
            .getColor(this.iconColor, 'FOREGROUND', this.$vuetify.theme.dark, false);
    }

    get buttonColor() {
        return COLOR_SERVICE_INSTANCE.getColor(this.bgColor, 'BACKGROUND', this.$vuetify.theme.dark, false);
    }
}
